import React from 'react'
import {
  LeadsListEmptyContainer,
  LeadsListEmptyTitle,
  LeadsListEmptyDescription,
} from './LeadsListEmpty.styles'
import {
  Box,
  IconWarningAlarmDeleteError,
  ShapeIcons,
} from '@creditas-ui/react'

const LeadsListEmpty = () => {
  return (
    <LeadsListEmptyContainer>
      <Box
        maxWidth={312}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Box mb={24}>
          <ShapeIcons size="x_small" Icon={IconWarningAlarmDeleteError} />
        </Box>
        <LeadsListEmptyTitle>Nenhum cliente encontrado</LeadsListEmptyTitle>
        <LeadsListEmptyDescription variant="paragraph">
          Por favor, revise os filtros utilizados e tente novamente
        </LeadsListEmptyDescription>
      </Box>
    </LeadsListEmptyContainer>
  )
}

export { LeadsListEmpty }
